var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"placement":"top"}},[_c('template',{slot:"title"},[_c('span',[_vm._v(_vm._s(_vm.message))])]),_c('a-button',{attrs:{"shape":"circle","icon":"question"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }